import { SettingValues } from './../pages/tourDetails/Settings/components/SettingTag/SettingTag';
import { stateClassOption, ticketSalesOption, tripleOption } from '../constant/setting';
import { SettingsRankingTypeEnum } from '../types/enums';
import { getBool } from './typeConverters';
import { toPersistedTeamMatchupScoring } from './groupStandingsTieBreakers';

// TO DO: Working. Added double translation for safety. Rework after demo
export const settingTagTypeConverter = (
  settingValues: SettingValues,
  translationHook: (key: string) => string
): any => {
  return {
    settings: {
      keywordSport: Number(settingValues.keywordSport),
      tour: settingValues.tour ? Number(settingValues.tour) : null,
      keywordTournamentType: Number(settingValues.keywordTournamentType),
      status: tripleOption.findIndex(
        (option) => translationHook(option) === translationHook(settingValues.status)
      ),
      showOnPublicPage: getBool(settingValues.showOnPublicPage),
      liveStreaming: getBool(settingValues.liveStreaming),
      liveStreamingLink: settingValues.liveStreamingLink,
      isRating: getBool(settingValues.isRating),
      ratingType: Number(settingValues.ratingType),
      isRanking: getBool(settingValues.isRanking),
      rankingType: Number(settingValues.rankingType) ?? SettingsRankingTypeEnum.RANKING_300p,
      isCanRecordScores: getBool(settingValues.isCanRecordScores),
      groupStandingsTieBreakers: settingValues.useInheritedGroupStandingsTieBreakers
        ? null
        : settingValues.groupStandingsTieBreakers ?? null,
      teamMatchupScoring: toPersistedTeamMatchupScoring(
        Boolean(settingValues.useInheritedTeamMatchupScoring),
        settingValues.teamMatchupScoring,
      ),
      // matchPoints: Number(settingValues.matchPoints),
    },
    currency: settingValues.currency || null,
    isDiscount: getBool(settingValues.isDiscount),
    discount1: Number(settingValues.discount1),
    discount2: Number(settingValues.discount2),
    discount3: Number(settingValues.discount3),
    classSettings: {
      stateOfClass: Boolean(
        stateClassOption.findIndex(
          (state) => translationHook(state) === translationHook(settingValues.stateOfClass)
        )
      ),
      keywordBall: Number(settingValues.keywordBall),
      keywordSurface: Number(settingValues.keywordSurface),
      isTicketSales: Boolean(
        ticketSalesOption.findIndex(
          (state) => translationHook(state) === translationHook(settingValues.isTicketSales)
        )
      ),
      isShowSalesButton: getBool(settingValues.isShowSalesButton),
      minPlayers: Number(settingValues.minPlayers),
      maxPlayers: Number(settingValues.maxPlayers),
      minTeamRoster: Number(settingValues.minTeamRoster),
      maxTeamRoster: Number(settingValues.maxTeamRoster),
      price: getBool(settingValues.isPaidClass) ? Number(settingValues.price) : 0,
      vat:
        getBool(settingValues.isPaidClass) && getBool(settingValues.useVat)
          ? Number(settingValues.vat)
          : 0,
      isDupr: getBool(settingValues.isDupr),
      requiresLicense: getBool(settingValues.requiresLicense),
    },
  };
};
